function forEach(list, cb) {
  return Array.prototype.forEach.call(list, cb);
}

function filter(list, cb) {
  return Array.prototype.filter.call(list, cb);
}

export function run() {
  const containers = document.querySelectorAll("[data-controller=RequireCheckbox]");

  forEach(containers, (container) => runInstance(container));
}

function runInstance(container) {
  const minimumRequired = parseInt(container.dataset.requireCheckboxMinimumCount, 10);

  const checkboxTargets = container.querySelectorAll("[data-target=required-checkbox]");
  const submitButtonTarget = container.querySelector("[data-target=submit-button]");

  function getCheckedCount() {
    return filter(checkboxTargets, (t) => t.checked).length;
  }

  function handleChange() {
    const checkedCount = getCheckedCount();
    const enoughChecked = checkedCount >= minimumRequired;

    submitButtonTarget.disabled = !enoughChecked;
  }

  forEach(checkboxTargets, (checkbox) => {
    checkbox.addEventListener("change", handleChange);
  });

  handleChange();
}
